import './style.css'
import { TZDate } from '@date-fns/tz';
import { isBefore, startOfDay } from 'date-fns';
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { CardListProps } from './types'
import { useNavigate } from 'react-router-dom'

function CardList(props: CardListProps) {
  const { cards } = props;
  const navigate = useNavigate();
  const now = new TZDate(startOfDay(new Date()), 'America/Chicago');

  const handleClick = (url: string) => {
    navigate(url);
  };

  return (
    <Row>
      {cards.map(item => (!item.date || !isBefore(now, item.date)) && (
        <Col xxl={3} lg={4} md={6} sm={12} key={item.url}>
          <Card bg="dark" className="Item" onClick={() => handleClick(item.url)} style={{width: '18rem'}}>
            <Card.Img variant="top" src={item.img} style={{objectFit: 'cover', height: '150px'}} />
            <Card.Body>
              <Card.Title>{item.name}</Card.Title>
              <Card.Text>
                {item.description}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  )
}

export default CardList;
